import { MOTION_TYPE_INFO, MotionType } from 'consts/motionType';
import Chip from 'lib/Chip';

interface MotionChipProps {
  motionType: MotionType;
}

const MotionChip: React.FC<MotionChipProps> = ({ motionType }) => {
  return <Chip label={MOTION_TYPE_INFO[motionType].name} icon={MOTION_TYPE_INFO[motionType].icon} />;
};

export default MotionChip;
